import { render, staticRenderFns } from "./ProgrammeIndex.vue?vue&type=template&id=09702f35&lang=pug&"
import script from "./ProgrammeIndex.vue?vue&type=script&lang=js&"
export * from "./ProgrammeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports